import React from "react";
import { css } from "@emotion/react";
import PlusIcon from "../../../img/butter_svgs/PlusIcon.svg?react";
import { FlexContainer } from "../../../containers/FlexContainer";
import { Button } from "../../general/Button/Button";
import { PropsOf } from "@emotion/react/dist/emotion-react.cjs";

interface PlusButtonProps {
  isDisabled: boolean;
  onClick: PropsOf<typeof Button>["onClick"];
}

export const PlusButton: React.FC<PlusButtonProps> = ({ isDisabled, onClick }) => {
  return (
    <Button
      textSize="Extra Large"
      buttonType="quaternary"
      isDisabled={isDisabled}
      buttonCss={css`
        display: flex;
        padding: 6px;
        justify-content: center;
        align-items: center;
        gap: 2px;
      `}
      onClick={onClick}
    >
      <FlexContainer
        css={css`
          justify-content: center;
          height: 20px;
          width: 20px;
        `}
      >
        <PlusIcon width={10} height={10} />
      </FlexContainer>
    </Button>
  );
};
